// update state
const setActionUserName = (payload) => {
    return {
        type: "USERNAME",
        payload
    }

}

export default setActionUserName;




// WEBPACK FOOTER //
// ./src/actions/setActionUserName.js